<div class="quotes">
  @if (selectedEstimate(); as selected) {
    <app-quote-details
      [estimate]="selected"
      [order]="order()"
      [isLowestRate]="isLowestRate(selected)"
      (back)="onBack()"
      (quoteConfirmed)="quoteConfirmed.emit($event)"
    />
  } @else if (isInProgress()) {
    <app-quote-progress [order]="order()!" />
  } @else if (isFinalQuoteView() && selectedVendorEstimate(); as finalEst) {
    <!-- ── FINAL QUOTE section ───────────────────────────────────────── -->
    <section class="quotes__final" aria-label="Final quote">
      <h3 class="quotes__final-heading">FINAL QUOTE</h3>

      <article class="quotes__final-card">
        <span class="quotes__final-vendor">{{ finalEst.name ?? 'Unknown Vendor' }}</span>

        <!-- Info row -->
        <div class="quotes__final-info">
          <div class="quotes__final-info-col">
            <span class="quotes__final-info-label">Delivery type</span>
            <span class="quotes__final-info-value">{{ selectedDeliveryType() }}</span>
          </div>
          <div class="quotes__final-info-col">
            <span class="quotes__final-info-label">Delivery date</span>
            <span class="quotes__final-info-value">{{ selectedDeliveryDate() }}</span>
          </div>
          <div class="quotes__final-info-col">
            <span class="quotes__final-info-label">Quote ID</span>
            <span class="quotes__final-info-value">{{ selectedQuoteId() }}</span>
          </div>
        </div>

        <!-- Cost breakdown -->
        @if (selectedCostBreakdown().length) {
          <div class="quotes__final-breakdown">
            @for (item of selectedCostBreakdown(); track item.concept) {
              <div class="quotes__final-breakdown-row">
                <span class="quotes__final-breakdown-concept">{{ item.concept }}</span>
                <span class="quotes__final-breakdown-cost">{{ item.cost | currency: selectedCurrency() }}</span>
              </div>
            }
          </div>
        }

        <!-- Total cost -->
        <div class="quotes__final-total">
          <span class="quotes__final-total-label">Total cost</span>
          <span class="quotes__final-total-value">{{ selectedTotalCost() | currency: selectedCurrency() }}</span>
        </div>

        <!-- PO number -->
        @if (order()?.vendorPrice) {
          <div class="quotes__final-po">
            <span class="quotes__final-po-label">Purchase Order ID</span>
            <span class="quotes__final-po-value">{{ order()?.vendorPrice }}</span>
          </div>
        }
      </article>
    </section>

    <!-- ── Previous Estimated Quotes (collapsible) ───────────────────── -->
    @if (previousEstimates().length) {
      <section class="quotes__previous">
        <button
          type="button"
          class="quotes__previous-toggle"
          (click)="togglePreviousQuotes()"
          [attr.aria-expanded]="previousQuotesExpanded()"
        >
          <svg
            class="quotes__previous-chevron"
            [class.quotes__previous-chevron--expanded]="previousQuotesExpanded()"
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            aria-hidden="true"
          >
            <path d="M1 1L5 5L9 1" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Estimated Quotes
        </button>

        @if (previousQuotesExpanded()) {
          <div class="quotes__previous-list">
            @for (
              estimate of previousEstimates();
              track estimate.vendorId ?? estimate.estimationsId ?? $index
            ) {
              <app-quote-card
                [order]="order()!"
                [estimate]="estimate"
                [orderDeadline]="orderDeadline()"
                [isLowestStandard]="isLowestRate(estimate)"
                (viewDetails)="onViewDetails($event)"
                (quoteConfirmed)="quoteConfirmed.emit($event)"
              />
            }
          </div>
        }
      </section>
    }
  } @else {
    @if (estimates().length) {
      @if (hasAnyEstimates()) {
        @for (
          estimate of allEstimates();
          track estimate.vendorId ?? estimate.estimationsId ?? $index
        ) {
          <app-quote-card
            [order]="order()!"
            [estimate]="estimate"
            [orderDeadline]="orderDeadline()"
            [isLowestStandard]="isLowestRate(estimate)"
            (viewDetails)="onViewDetails($event)"
            (quoteConfirmed)="quoteConfirmed.emit($event)"
          />
        }
      }
    } @else if (order()?.jobStatus === "NOT_AVAILABLE") {
      <div class="quotes__not-available" role="status" aria-live="polite">
        <mat-icon class="quotes__not-available-icon" aria-hidden="true">warning</mat-icon>
        <p class="quotes__not-available-text">
          No matching suppliers cover the selected language(s).
          <br>
          For assistance, please contact
          <a
            class="quotes__not-available-link"
            href="mailto:AZTranslate@astrazeneca.com"
            >support</a
          >.
        </p>
      </div>
    } @else {
      <p class="quotes__empty">No vendors assigned yet.</p>
    }
  }
</div>